import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store, key } from "./store";
import Vant from "vant";
import "vant/lib/index.less";
import "@/assets/style/index.less";
import Components from "@/components";

createApp(App)
  .use(store, key)
  .use(router)
  .use(Vant)
  .use(Components)
  .mount("#app");
